module.exports = __webpack_public_path__ + "static/media/Acc-2d.aeb57555.png";